// Components
import { useCallback, useEffect } from 'react';
import DiscardConfirmation, {
  useDiscardConfirmation,
} from 'components/DiscardConfirmation';
// Utils
import { getText } from 'i18n/intl';
// Slices
import {
  checkDisabled,
  fetchReservationModes,
} from 'slices/reservationMode.slice';
import { useAppDispatch } from 'slices/store';
import { DefaultContentLayout } from '@timeedit/ui-components';
import ReservationModeDrawer from './ReservationModesDrawer';
import ReservationModeList from './ReservationModesList';

const ReservationModesPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchReservationModes());
  }, []);

  const [
    openDiscardDialog,
    onCloseDiscardDialog,
    confirmFn,
    confirmDiscardChanged,
  ] = useDiscardConfirmation();

  const confirmDiscardChanges = useCallback(
    (isFirstDrawer: boolean, actionFn: () => void) => {
      const isFieldRelationDisabled = dispatch(checkDisabled(isFirstDrawer));
      if (!isFieldRelationDisabled) {
        return confirmDiscardChanged(actionFn);
      }
      actionFn();
    },
    []
  );

  return (
    <DefaultContentLayout
      title={getText('reservation_modes')}
      subtitle={getText('reservation_mode_sub_title')}
    >
      <div className="inner-content--wrapper">
        <ReservationModeList confirmDiscardChanges={confirmDiscardChanges} />
        <ReservationModeDrawer confirmDiscardChanges={confirmDiscardChanges} />
      </div>
      <DiscardConfirmation
        open={openDiscardDialog}
        onClose={onCloseDiscardDialog}
        confirmFn={confirmFn}
      />
    </DefaultContentLayout>
  );
};

export default ReservationModesPage;
